import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-validation-summary-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './validation-summary-modal.html',
  styleUrl: './validation-summary-modal.scss'
})
export class ValidationSummaryModalComponent {
  @Input() visible = false;
  @Input() title = 'Información incompleta';
  @Input() message = 'Revisa los siguientes campos antes de continuar:';
  @Input() items: string[] = [];

  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
